<template>
  <div class="managingPeople hp100 bbox" v-loading="loading">
    <!-- 卡片视图 -->
    <el-card>
      <!-- 搜索-->
      <el-row :gutter="20" type="flex" justify="space-between">
        <el-col>
          <!-- <el-button
            plain
            class="add-column-btn bbox"
            @click="gotoDetail('')"
            type="primary"
          >
            <i class="el-icon-plus fw900 f16"></i> 新增</el-button
          > -->
          <el-button
            plain
            class="add-column-btn bbox"
            type="warning"
            @click="chooseDelete"
          >
            <i class="el-icon-delete fw900 f16"></i> 删除</el-button
          >
        </el-col>
        <el-col>
          <div class="flex align-center justify-end header-search-box">
            <el-input
              placeholder="请输入项目名称"
              clearable
              v-model="searchInput"
              class="header-search-input ml10"
              @change="search"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                class="textblue searchBtn"
                @click="search()"
              ></el-button>
            </el-input>
          </div>
        </el-col>
      </el-row>
      <!-- 用户列表区域 -->
      <div :style="{ height: height + 'px' }" style="margin-top: 20px">
        <el-scrollbar style="height: 100%; width: 100%">
          <el-row style="width: 100%">
            <el-table
              :data="tableData"
              border
              fit
              highlight-current-row
              style="width: 100%"
              @sort-change="sortChange"
              @row-click="singleElection"
            >
              <el-table-column align="center" width="50" label="选择">
                  <template slot-scope="scope">
                    <!-- 可以手动的修改label的值，从而控制选择哪一项 -->
                    <el-radio
                      class="radio"
                      v-model="templateSelection"
                      :label="scope.row.nodeCode"
                      >&nbsp;</el-radio
                    >
                  </template>
                </el-table-column>
              <el-table-column
                label="项目名称"
                align="center"
                prop="projectName"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.projectName }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="节点名称"
                align="center"
                prop="nodeName"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.nodeName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="工程师" align="center" prop="nodeLeaderName">
                <template slot-scope="scope">
                  <span>{{ scope.row.nodeLeaderName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="预计完成时间" align="center" prop="expectFinishTime">
                <template slot-scope="scope">
                  <span v-if="scope.row.expectFinishTime">{{ scope.row.expectFinishTime | dataFormatT}}</span>
                  <span v-if="!scope.row.expectFinishTime"></span>
                </template>
              </el-table-column>
              <el-table-column label="实际完成时间" align="center" prop="actualConclusionTime">
                <template slot-scope="scope">
                  <span v-if="scope.row.actualConclusionTime">{{ scope.row.actualConclusionTime | dataFormatT}}</span>
                  <span v-if="!scope.row.actualConclusionTime">未完成</span>
                </template>
              </el-table-column>
              <el-table-column label="分配日期" align="center" prop="distributionTime">
                <template slot-scope="scope">
                  <span v-if="scope.row.distributionTime">{{ scope.row.distributionTime | dataFormatT}}</span>
                  <span v-if="!scope.row.distributionTime"></span>
                </template>
              </el-table-column>
              <el-table-column label="节点状态" align="center" prop="nodeStatus">
                <template slot-scope="scope">
                  <span style="color:red" v-if="scope.row.nodeStatus == '0'">待处理</span>
                  <span style="color:green" v-else-if="scope.row.nodeStatus == '4'">已完成</span>
                  <span style="color:gray" v-else-if="scope.row.nodeStatus == '5'">挂起</span>
                  <span style="color:#22a5f1" v-else-if="scope.row.nodeStatus == '1'">待跟进</span>
                  <span style="color:#22a5f1" v-else-if="scope.row.nodeStatus == '2'">协助处理</span>
                  <span style="color:#22a5f1" v-else>处理中</span>
                </template>
              </el-table-column>
              <el-table-column label="立项日期" align="center" prop="projectApprovalTime">
                <template slot-scope="scope">
                  <span v-if="scope.row.projectApprovalTime">{{ scope.row.distributionTime | dataFormatT}}</span>
                  <span v-if="!scope.row.projectApprovalTime"></span>
                </template>
              </el-table-column>
            </el-table> </el-row
        ></el-scrollbar>
      </div>
      <div class="footerBox">
        <!-- 分页区域 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="queryInfo.currPage"
                   :page-sizes="[100, 10, 20, 30, 50]"
          :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      height: window.innerHeight - 256, //表格高度
      value: "",
      searchInput: "",
      tableData: [],
      loading: true,
      // 获取用户列表查询参数对象
      queryInfo: {
        // 当前页数
        currPage: 1,
        // 每页显示多少数据
        pageSize: 100,
        //查询条件
        condition: {
          id: "",
        },
      },
      userlist: [],
      total: 0,
      // 添加用户对话框
      addDialogVisible: false,
      // 用户添加
      addUserForm: {
        username: "",
        password: "",
        email: "",
        mobile: "",
      },
      // 修改用户
      editDialogVisible: false,
      editUserForm: {},
      // 分配角色对话框
      setRoleDialogVisible: false,
      checkList: [],
      templateSelection:""
    };
  },
  created() {
    this.getListData();
    window.addEventListener("resize", this.getHeight);
  },
  mounted() {
    this.loading = false;
  },
  destroyed() {
    window.removeEventListener("resize", this.getHeight);
  },
  methods: {
    //条件查询
    search() {
      this.queryInfo.condition.projectName = this.searchInput;
      this.getListData();
    },
    // 监听 pagesize改变的事件
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getListData();
    },
    // 监听 页码值 改变事件
    handleCurrentChange(newSize) {
      this.queryInfo.currPage = newSize;
      this.getListData();
    },

    // 监听排序
    sortChange() {},
    getListData() {
      // 获取列表
      var that = this;
      that.$http
        .post("/projectNodes/list", that.queryInfo)
        .then(function (response) {
          console.log(response.data.data);
          if (response.data.code == 200) {
            that.total = response.data.data.count;
            that.queryInfo.currPage = response.data.data.currPage;
            that.tableData = response.data.data.data;
          }
        });
    },
    // 监听表格高度
    getHeight() {
      this.height = window.innerHeight - 256;
    },
    // 选择节点
    singleElection(row) {
      this.templateSelection = row.nodeCode;
      this.checkList = this.tableData.filter((item) => item.id === row.id);
      console.log(`该行的id为${row.nodeCode}`, this.checkList,this.templateSelection);
    },
    // 选择删除
    chooseDelete() {
      if (this.checkList.length == 0) {
        this.$message("请选中一条记录！");
        return;
      }
      let sendData = {};
      sendData.nodeCode = this.templateSelection;
      this.$http.post("/projectNodes/delete", sendData).then((res) => {
        console.log(res.data.data);
        if (res.data.code == 200) {
          this.$notify.success({
            title: "提示",
            message: "删除成功",
            showClose: true,
          });
          this.getListData();
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.textblue {
  color: #008eff;
}
.managingPeople {
  .el-card {
    height: calc(100vh - 114px);
    position: relative;
    .el-select > .el-input {
      width: 200px;
    }
    .header-search-box .header-search-input {
      width: 325px;
    }
    input::placeholder {
      font-size: 12px;
    }
    .handle-btn .el-button.add-column-btn {
      width: 100%;
      font-size: 13px;
      background-color: transparent;
      color: #008eff;
      z-index: 102;
    }
    .footerBox {
      position: absolute;
      width: 100%;
      height: 78px;
      left: 20px;
      right: 20px;
      bottom: 0;
    }
  }
}
/deep/.el-scrollbar__view {
  min-width: 100%;
}
/deep/.el-scrollbar__wrap {
  overflow-x: auto;
  height: calc(100%); //多出来的20px是横向滚动条默认的样式
  width: 100%;
}
/deep/.el-scrollbar .el-scrollbar__wrap .el-scrollbar__view {
  white-space: nowrap;
  display: inline-block;
}
</style>

